import { CheckCircleIcon } from "@heroicons/react/24/solid";
import ChoiceResponseResource from "common/resources/Choice/ChoiceResponseResource";
import LazyImage from "components/elements/LazyImage";
import Typography from "components/elements/Typography";
import classes from "./classes.module.scss";

type IProps = {
	percentage: string;
	imageUrl: string | null;
	choice: ChoiceResponseResource;
};

export default function ResultOption({ percentage, imageUrl, choice }: IProps) {
	return (
		<div className={classes["result-container"]} style={{ "--percentage": percentage }}>
			<div className={classes["choice-container"]}>
				{imageUrl && <LazyImage src={imageUrl} alt={choice.value} className={classes["avatar"]} />}
				<Typography type="p" weight="regular" className={classes["label"]}>
					{choice.value}
				</Typography>
				{choice.votes.length > 0 && <CheckCircleIcon className={classes["check-icon"]} />}
			</div>

			<Typography type="p" weight="medium">
				{percentage}
			</Typography>
		</div>
	);
}
